/**
 *
 */
export enum OwnerTypeID {
  PrivateOwner = 1,
  Roommate = 2,
  RealEstateAgent = 4,
  Other = 8,
}
